export const generateBengaliCouponCode = () => {
    const bengaliDigits = ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"];
    let randomDigits = "";
  
    for (let i = 0; i < 4; i++) {
      randomDigits += bengaliDigits[Math.floor(Math.random() * 10)];
    }
  
    return `শব্দল-${randomDigits}`;
  };